import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';

import { PrClient, ProductClientService } from '../../services/product-client.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { EmployeeService } from '../../services/employee.service';
import { ProductVntaService } from '../../services/product-vnta.service';
import { Subscription } from 'rxjs';
import { toast } from 'angular2-materialize';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { TransitionCheckState } from '@angular/material';
import { Utils } from '../../util';

@Component({
  selector: 'app-read-pr-client',
  templateUrl: './read-pr-client.component.html',
  styleUrls: ['./read-pr-client.component.css']
})
export class ReadPrClientComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};
  loading: boolean[] = [false, false, false];
  get loaded(): boolean { return !this.loading.includes(false); }

  customerSelect: any[] = [];
  currentCustomerId: string = '';

	data:Array<any> = [];
  rows:Array<any> = [];
  columns:Array<any> = [
    {title: 'Producto' , name: 'name',sort: 'asc'},
    {title: 'Clave Prod' , name: 'code'},
    {title: 'Versión' , name: 'version'},
    {title: 'Estatus PP' , name: 'designStatus'},
    {title: 'Estatus Cal' , name: 'qualityStatus'},
    {title: 'Cliente', name: 'customerName'},
    {title: 'Ejecutivo a cargo', name: 'employeeName'},
    { title: 'Acciones', className: 'center',  name: 'actionGroup', sort: false, actions: {
      type: 'group',
      buttons: [
				{ name: 'duplicate', title: '', styleIcon: 'queue', action: 'onDuplicate', styleClass: 'btn-floating btn waves-effect light-blue darken-1' },
        { name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit', styleClass: 'btn-floating btn waves-effect light-green darken-1' },
        { name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete', styleClass: 'btn-floating btn waves-effect red darken-2', }
      ]
    }}
  ];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config:any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: `${localStorage.readPrClientFilterString || ''}`},
		api: {
      onDuplicate: this.onDuplicate.bind(this),
			onEdit: this.onEdit.bind(this),
			onDelete: this.onDelete.bind(this)
		}
  };

  customersData = {};
  employeesData = {};
  prVntasData = {};

  prClientSub: Subscription;
  customerSub: Subscription;

  constructor(
    private service: ProductClientService,
    private customerService: CustomerSupplierService,
    private employeeService: EmployeeService,
    private prVntaService: ProductVntaService,
    private settings: CatalogsSettingsService,
		private permissionService: PermissionService,
		private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
        if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
        else this.allowed = true;
    });

    let setSub =  this.settings.getPayrollSettings('1').subscribe(setting => {
      setSub.unsubscribe();
      this.itemsPerPage = setting.tableQuantity;
      this.loading[0] = true;
    });
    this.customerSub = this.customerService.getCustomers().subscribe(customers => {
      if(!customers.length) return;
      this.customerSelect = customers.map(({id$: value, name}) => ({value, name}) ).sort(({name: n1}, {name:n2}) => n1 > n2 ? 1 : -1);
      this.currentCustomerId = this.customerSelect[0].value;
      if(localStorage.readPrClientFilterCustomerId){
        if(this.customerSelect.find(({value}) => value == localStorage.readPrClientFilterCustomerId)){
          this.currentCustomerId = localStorage.readPrClientFilterCustomerId;
        }
      }
      this.getPrClients(this.currentCustomerId);
      
      window['reportNow'] = this.generateExcelForReport;
      this.loading[1] = true;
      //this.loading[2] = true;
    });
    //add activity
    /* this.prClientSub = service.getPrClients().subscribe(prClients => {
      this.prClientSub.unsubscribe();
      let ranges = [
        {max: 1000, min: 0, price: 300},
        {max: 3000, min: 1001, price: 250},
        {max: 7000, min: 3001, price: 200},
        {max: 9000, min: 7001, price: 150},
        {max: 15000, min: 9001, price: 100},
        {max: 10000000, min: 15001, price: 90},
      ]
      let a ={ name: '203 - Impresión Vuelta', actId: 'BEnUaaNq4GuF7qTyJlQf', classification: '2 - Prensa', quantityPricesFunction: 'tiros', dataCalc: 0, prices: [], ranges, unique: {} };
      prClients.map(({id, sections: [s1, s2], ...prClient}) => {
        let newSections = [];
        if(s1 && s1.backInk > 0){
          s1.activities = s1.activities.map(({name, ...a}) => ({ name: name.replace('201 - Impresión', '201 - Impresión Frente'), ...a }));
          s1.activities.push(a);
          newSections.push(s1);
        }
        if(s2 && s2.backInk > 0){
          s1.activities = s1.activities.map(({name, ...a}) => ({ name: name.replace('201 - Impresión', '201 - Impresión Frente'), ...a }));
          s2.activities.push(a);
          newSections.push(s2);
        }
        //console.log(newSections);
        service.updatePrClient(id, {sections: newSections});
      })
    }) */
    //////////////////////////////addActivities
    /* let sub = service.getPrClients().subscribe(prCLients => {
      sub.unsubscribe();
      console.log(prCLients.length);
      let onlyPrClients = prCLients.filter(({generalActivities}) => !generalActivities.length);
      console.log(onlyPrClients.length);
      onlyPrClients.map(prCLient => {
        let generalActivities = [generalActivity];
        let sections = prCLient.sections.map(section => {
          let [first, ...rest] = section.activities;
          if(first) section.activities = [first, sectionActivities[0], ...rest, sectionActivities[1], sectionActivities[2] ];
          else section.activities = [sectionActivities[0], ...rest, sectionActivities[1], sectionActivities[2] ];
          return section;
        });
        service.updatePrClient(prCLient.id, {generalActivities, sections});
      })
      this.loading = [true];
    });
    var sectionActivities = [
      { name: '105 - Corte inicial', classification: '1 - PrePrensa', quantityPricesFunction: 'corte', dataCalc: 3, prices: [0,0,0], ranges: [], unique: {} },
      { name: '308 - Desbarbar', classification: '3 - PostPrensa', quantityPricesFunction: 'pegado', dataCalc: 1, prices: [0], ranges: [], unique: {} },
      { name: '309 - Pegado', classification: '3 - PostPrensa', quantityPricesFunction: 'pegado', dataCalc: 1, prices: [0], ranges: [], unique: {} },
    ]
    var generalActivity = { name: '401 - Empaque', classification: '4 - Acabados', quantityPricesFunction: 'empaque', dataCalc: 2, prices: [0,0], ranges: [], unique: {} }; */
    //////////////////////////////addActivities
    /* this.loading[1] = true;
    let str = localStorage.prClientsJson.replace(new RegExp('\n','g'), '<br />')//.replace(new RegExp('\"','g'), '<QUOTES>' )
    JSON.parse(str).map((prClient, index) => {
      let obj = new PR_CLIENT(prClient).prClient;
      obj.characteristics = obj.characteristics.replace(new RegExp('<br />','g'), '\n')
      obj.designComments = obj.designComments.replace(new RegExp('<br />','g'), '\n')
      obj.qualityComments = obj.qualityComments.replace(new RegExp('<br />','g'), '\n')
      //Object.keys(obj).map(key => {if(obj[key] === undefined) console.log('error_u' + key); else console.log('good')});
      this.service.addPrClient(obj);
    }); */
    /* let sub = service.getPrClients().subscribe(prClients => {
      sub.unsubscribe();
      let prClientsObj = prClients.reduce((acc, cur) => {
        acc[cur.id] = cur.sections;
        return acc;
      }, {});
      SECTIONS.map(({prClientId, ...section}) => {
        prClientsObj[prClientId].push(section);
      });
      prClients.map((prClient, index) => {
        this.service.updatePrClient(prClient.id, { sections: prClientsObj[prClient.id] });
      });

      this.loading[1] = true;
    }); */
  }
  ngOnDestroy(){
    this.prClientSub.unsubscribe();
    this.customerSub && this.customerSub.unsubscribe();
  }

  ngOnInit() {
    window['com'] = this;
  }

  getPrClients(customerId: string){
    this.loading[2] = false;
    this.data = [];
    this.length = this.data.length;
    this.onChangeTable(this.config);
    this.prClientSub = this.service.getPrClients({customerId, onEmpty: () => {
      this.loading[2] = true;
    } }).subscribe(prClients => {
      console.log(`PrClientes`)
      console.log(prClients);
      /* localStorage.prClientPln = JSON.stringify(tempPrClients.reduce((acc,cur) => {
        acc[cur.IDPln] = cur.id;
        return acc;
      }, {}) ); */
      this.data = prClients.map(prClient => {
        prClient.customerName = prClient.customerObj.name;
        prClient.employeeName = `${prClient.employeeObj.name.trim()} ${prClient.employeeObj.lastName.trim()}`;
        prClient.name = prClient.prVntaObj.name;
        return prClient;
      });
      this.length = this.data.length;
      this.onChangeTable(this.config);
      this.loading[2] = true;
    });

  }

  reported = false;
  allPrClients = [];
  async generateExcelForReport(self){
    if(self.reported) return;
    self.reported = true;
    let headers = [
      'name',
      'code',
      'version',
      'designStatus',
      'qualityStatus',
      'customerName',
      'employeeName',
      'isLineProduct',
      'isLastVersion',
      'codeGivenBy',
      'barCode',
      'designStatus',
      'designComments',
      'qualityStatus',
      'qualityComments',
      'shortDescription',
      'longDescription',
      'processOwnerComments',
      'newVersionMotive',
      'IDPln',
      'agreedPrice',
      'characteristics',
      'agreedDate',
      'packaging',
      'valid',
      'pasteType',
      'flatNumber',
    ];
    let rows = [];
    console.log(`All customers: `, self.customerSelect);
    for(let customerOpt of self.customerSelect){
      if(customerOpt.value != "ZBnK0VZOMNOvGNy05Sci") continue;
      console.log('Customer: ' + `${customerOpt.value}_${customerOpt.name}`);
      let customPrClients = await new Promise<any[]>(resolve => {
        console.log('awaiting promise');
        let sub = self.service.getPrClients({customerId: customerOpt.value}).subscribe(prClients => {
          console.log('subDocs: ', prClients);
          sub.unsubscribe();
          console.log(`PrClientes de ${customerOpt.value}`, prClients);
          let custom = prClients.map(({packaging, ...prClient}) => {
            prClient.customerName = prClient.customerObj.name;
            prClient.employeeName = `${prClient.employeeObj.name.trim()} ${prClient.employeeObj.lastName.trim()}`;
            prClient.name = prClient.prVntaObj.name;
            prClient.packaging = `${packaging.wide}, ${packaging.long}, ${packaging.height}`;
            return prClient;
          });
          resolve(custom);
        });
      });
      console.log(`PrClientes de ${customerOpt.value}`, customPrClients)
      self.allPrClients.push(...customPrClients);
    }
    console.log('Rows: ', rows);
    for(let prClient of self.allPrClients){
      let row = [];
      for(let header of headers) row.push(prClient[header]);
      rows.push(row);
    }
    console.log('Rows: ', rows);
    Utils.downloadExcel([headers, ...rows], `ProductosDeCliente_${Utils.today}`);
    console.log('downloaded');
  }
  
  onChangeCustomer(id: string){
    this.currentCustomerId = id;
    localStorage.readPrClientFilterCustomerId = id;
    this.prClientSub.unsubscribe();
    this.getPrClients(id);
  }

  deletePrClient(sid: string) {
    this.service.deletePrClient(sid);
  }

  onCellClick(data: any): any {
		this.router.navigate(['/vw_prClient/' + data.row.id]);
  }

  onCreate(){
    if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
    this.router.navigate(['/new_prClient']);
  }

  onDuplicate({row}){
    if(!this.permission.createAction) return toast('No tiene los permisos para duplicar.', 2000);
    let {
      id, name, code, createdAt, updatedAt,
      customerName, customerObj, employeeName, employeeObj, prVntaObj, quotationObj,
      ...prClient
    } = row;
    prClient.code = prClient.codeGivenBy == 'Automática' ? `${customerObj.initials}-${this.ceroes(customerObj.nextProduct,4)}` : '';
    if(!confirm(`¿Duplicar el producto de cliente ${code}, versión ${prClient.version}?${prClient.code ? `\nPróximo código: ${prClient.code}` : '' }`)) return;
    localStorage.prClient = JSON.stringify(prClient);
    this.service.windowReplace('add');
  }

	onEdit(data: any) {
    if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
		this.router.navigate(['/edit_prClient/', data.row.id]);
	}

	onDelete(data: any) {
    if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
    return !this.service.prClientHasFile(data.row) ? this.deletePrClient(data.row.id) : toast('Para eliminar debe remover las imágenes de este producto.', 3000);
  }

  ceroes(digit,num){
    var str = digit + '';
    if(str.length < 4) return this.ceroes('0' + str,num);
    else return str;
  }

  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columns.forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columns.forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    console.log(config, config.filtering)
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
    localStorage.readPrClientFilterString = this.config.filtering.filterString || '';
  }

}
